module.exports = __webpack_public_path__ + "static/media/window.7c301afb.svg";